import React, {memo} from "react";
import {Button, Modal} from "react-bootstrap";
import BaseModal from "../BaseModal";
import {useDispatch, useSelector} from "react-redux";
import {actionModalChangeAddressChangeShow} from "../../../../../redux/actions/modals/modalChangeAddress";
import TitlesModals from "../TitlesModals";
import LoaderModals from "../../loaders/LoaderModals";
import {handelOpenModalShoppingCard} from "../../../../../redux/actions/modals/modalShoppingCard";
import {handelOpenModalAddAddress} from "../../../../../redux/actions/modals/modalAddAddress";
import {
    handelOpenModalSelectBaseMarket
} from "../../../../../redux/actions/modals/modalSelectBaseMarket";
import {actionRemoveItemAddress, actionSelectItemActiveAddress, actionGetAddressUser} from "../../../../../redux/actions/user/user";
import axios from "axios";
import {BASE_URL, USERS_DELETE_ADDRESS_POST, ORDER_CHANGE_ADDRESS, PUBLIC_URL_SERVER} from "../../../../../apis";
import qs from "querystring";
import swal from 'sweetalert';
import Swal from 'sweetalert2';
import {handelOpenModalEditAddress} from "../../../../../redux/actions/modals/address/modalEditAddress";
import {FaAddressCard, FaEdit, FaPlus, FaTrashAlt} from "react-icons/all";

import {actionChangeSelectOrderModalInvoice} from "../../../../../redux/actions/modals/modalInvoice/modalInvoice"; // age az safhe virayeshe sefaresh oomade bashim, dar soorate taghire address bayad addresse sefaresh taghir kone
import {actionModalChangeAddressChangeLoader} from "../../../../../redux/actions/modals/modalChangeAddress";

const ModalChangeAddress = () => {
    const dispatch = useDispatch();
    const {show, loader, destination, fromEditOrder} = useSelector(state => state.modalChangeAddress);
    const {address, activeAddress, token} = useSelector(state => state.user);
    const handleClose = () => {
        dispatch(actionModalChangeAddressChangeShow(false, destination));
    };


    const {order} = useSelector(state => state.modalInvoice);

    const btnOkSingle = Swal.mixin({
        customClass: {
            confirmButton: 'base-btn-green-border btn btn-success',
        },
        buttonsStyling: false
    });

    const handleChangeAddress = (activeAddress) => {
        /*
        kolan system be in shekl kar mikone ke:
        1- age karbar az safhye forooshgah ya jaye dige taghire address zade bashe, liste addressha be karbar namayesh dade mishe, addresse default ke dar local storage zakhire shode select mishe,
            va be mahze click rooye yeki az itemha, addresse pishfarz taghir mikone va dar local storage ham update mishe va forooshgaha mojadadan bargozari mishan, amalan yani dokmeye entekhabe address hich kare khasi anjam nmide va faghat modal ro mibande
        2- age karbar az safheye virayeshe sefaresh oomade bashe; vase inke tadakhol ba ghasemate ghabl pish nayad, va inke karbar ta rooye yeki az gozineha click mikone addresse pishfarze karbar taghir nakone, 
            kole addressharo mindazim too loop va hameye addressharo diselect mikonim va addresse entekhabi ri select mikonim bedoone inke dar local storage taghiri ijad konim.
            zamani ke karbar rooye dokmeye entekhabe address click kard api ro seda mizanim va addresse sefaresh ro taghir midim bazam kari be addresse pishfarz nadarim
        */



        // if(activeAddress.forEditOrder !== undefined && activeAddress.forEditOrder !== null) // az safheye virayeshe sefaresh oomade inja
        if(fromEditOrder) // az safheye virayeshe sefaresh oomade inja
        {
            if(parseInt(activeAddress.new_delivery_price) !== parseInt(activeAddress.old_delivery_price))
            {
                btnOkSingle.fire({
                    text: `مبلغ ارسال برای  این آدرس ${parseInt(activeAddress.new_delivery_price).toLocaleString()} تومان است.`,
                    imageUrl: PUBLIC_URL_SERVER + '/icons/fm_logo_ofoghi_new.png',
                    imageHeight: 45,
                    imageAlt: 'فروت مروت',
                    confirmButtonText: "باشه",
                });

            }

            address.map(function(item){
                if(item.addressId === activeAddress.addressId)
                    item.selectThis = true;
                else
                    item.selectThis = false;
            });
            dispatch(actionGetAddressUser(address));

            // dispatch(actionModalChangeAddressChangeLoader(true));
            // callApiChangeOrderAddress(activeAddress);
        }
        else 
            dispatch(actionSelectItemActiveAddress(activeAddress));
    };

    const callApiChangeOrderAddress = (activeAddress) => {
        dispatch(actionModalChangeAddressChangeLoader(true));
        
        axios({
            method: 'post',
            url: BASE_URL + ORDER_CHANGE_ADDRESS,
            data: qs.stringify({
                order : order.order,
                new_address : activeAddress.addressId,
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
        }).then((response) => {
            dispatch(actionModalChangeAddressChangeLoader(false));

            if(response.data.status === "ok") {
                let editOrder = order;
                editOrder.address = activeAddress.address;
                editOrder.selectInEditMode = true; // vase in set kardim ke age baz bargashtim be in safhe hamin address select shode bashe na addresse defaulte sefaresh
                dispatch(actionChangeSelectOrderModalInvoice(editOrder));

                dispatch(actionSelectItemActiveAddress(activeAddress));

                if(response.data.message !== undefined && response.data.message !== null)
                    btnOkSingle.fire({
                        text: response.data.message,
                        imageUrl: PUBLIC_URL_SERVER + '/icons/fm_logo_ofoghi_new.png',
                        imageHeight: 45,
                        imageAlt: 'فروت مروت',
                        confirmButtonText: "باشه",
                    }).then((response) => {
                        handleClose();
                    });
                else
                    handleClose();
            }
            else if(response.data.status === "error")
                swal({
                        text: response.data.message,
                        buttons: {
                            cancel: "باشه",
                        },
                        icon: "error",
                    });
        }).catch((error) => {
            dispatch(actionModalChangeAddressChangeLoader(false));
        });
    };

    const handelBackModalBasket = () => {
        

        if(fromEditOrder && address !== undefined)
        {
            address.map(function(item){
                if(item.forEditOrder !== undefined && item.forEditOrder !== null && item.selectThis) 
                {
                    callApiChangeOrderAddress(item);
                    return;
                }
            });
        }
        else
            handleClose();

        


        switch (destination) {
            case 'MODAL_CHANGE_SELECT_SHOPPING':
                dispatch(handelOpenModalSelectBaseMarket());
                break;
            case 'MODAL_LIST_PRODUCTS_BODY':
                dispatch(handelOpenModalShoppingCard());
                break;
            default:
        }
    };
    const handelModalAddAddressWhiteMap = () => {
        handleClose();
        dispatch(handelOpenModalAddAddress());
    };

    const handleDeleteAddress = (address) => {
        axios({
            method: 'post',
            url: BASE_URL + USERS_DELETE_ADDRESS_POST,
            data: qs.stringify({
                address_num: address.addressId
            }),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
        }).then((response => {
            if (response.data.status === 'ok') {
                swal({
                    text: 'آدرس مورد نظر با موفقیت حذف شد.',
                    buttons: {
                        cancel: "تایید",
                    },
                    icon: "success",
                });
                dispatch(actionRemoveItemAddress(address));
            }
        }));
    };

    const validateHandleDeleteAddress = (itemAddress) => {
        if (address.length > 1) {
            if (itemAddress.addressId !== activeAddress.addressId) {

                swal({
                    text: "آیا میخواهید این آدرس را حذف کنید؟",
                    buttons: {
                        cancel: "انصراف",
                        confirm: {
                            text: 'بله',
                            value: "ok",
                        },
                    },
                    icon: "warning",
                }).then((value) => {
                    if (value === 'ok') {
                        handleDeleteAddress(itemAddress);
                    }
                });
            } else {
                swal({
                    text: "نمیتوانید آدرسی که انتخاب کرده اید را حذف کنید.",
                    buttons: {
                        confirm: {
                            text: 'فهمیدم!',
                        },
                    },
                    icon: "error",
                });
            }
        } else {
            swal({
                text: "نمیتوان تمامی آدرس ها را حذف کرد.",
                buttons: {
                    confirm: {
                        text: 'فهمیدم!',
                    },
                },
                icon: "error",
            });
        }

    };

    const handleEditAddress = (itemAddress) =>{
        handleClose();
        dispatch(handelOpenModalEditAddress(itemAddress));

    };
    return (
        <BaseModal title={'تغییر آدرس'}
                   show={show}
                   dialogClassName={''}
                   handleClose={handleClose}>
            <Modal.Body>
                {!loader ?
                    <div>
                        <div>
                            <TitlesModals>
                                <FaAddressCard className={'mr-2'}/>
                                <span>لیست آدرس های شما</span>
                            </TitlesModals>
                            <ul className={'list-show-all-address-in-modal-change-address'}>
                                {address !== undefined ? address.map((item, index) => (
                                    <li key={index} className='item-in-list-address-modal-address'>
                                        <div onClick={() => handleChangeAddress(item)}>
                                            <div className={'cm-box-radio-group-select-address'}>
                                                {(  (item.forEditOrder !== undefined && item.forEditOrder !== null && item.selectThis) || (item.forEditOrder === undefined && Object.keys(activeAddress).length > 0 && activeAddress.addressId === item.addressId)  ) ?
                                                    <div className={'cm-radio-group-select-address'}/>
                                                    : ''}
                                            </div>
                                            <p>{item.address}</p>
                                        </div>
                                        <div>
                                            <div className={'btn mr-1 ml-1 d-inline-block'}
                                                 onClick={() => handleEditAddress(item)}>
                                                <FaEdit className={'text-success'}/>
                                            </div>
                                            <div className={'btn mr-1 ml-1 d-inline-block'}
                                                 onClick={() => validateHandleDeleteAddress(item)}>
                                                <FaTrashAlt className={'text-success'}/>
                                            </div>
                                        </div>
                                    </li>
                                )) : ''}

                            </ul>
                        </div>
                    </div>
                    :
                    <LoaderModals/>}
            </Modal.Body>
            <Modal.Footer className={'cm-footer-modal-change-address'}>
                <div className={'w-100'}>
                    <Button variant="success" className={'base-btn-green-border mb-1'} block
                            onClick={handelModalAddAddressWhiteMap}>
                        <FaPlus className={'mr-1'}/>
                        <span>افزودن آدرس جدید</span>
                    </Button>
                    <Button variant="success" className={'base-btn-green'} block onClick={handelBackModalBasket}
                            disabled={loader}>
                        <span>انتخاب آدرس</span>
                    </Button>
                </div>
            </Modal.Footer>
        </BaseModal>
    );
};

export default memo(ModalChangeAddress);
